import { HttpMethods, useRequest } from '@dnb/api-handler';
import { Endpoints } from '@pm-netbank/endpoints';
import { OddFormContextState } from '../types/context';

function useOddForm(): OddFormContextState {
  const fetchOddRequest = useRequest(HttpMethods.GET, Endpoints.odd.form(), {
    executeImmediately: true,
  });

  return {
    isLoading: fetchOddRequest.isLoading !== false,
    data: fetchOddRequest.data,
    error: fetchOddRequest.error,
  };
}

export default useOddForm;
